export default __webpack_public_path__ + "static/sky_news-3ef4c0fd4a5bf09c29a896711ccc7a01.png";